


























import Vue from 'vue';
import LearningTools from '@/tools/learning';
import BbTools from '@/tools/bluebird';
import Activity from '@/components/activity/Activity.vue';
import ActivityStatus from '@/components/activity/ActivityStatusText.vue';

export default Vue.extend({
  components: {
    activity: Activity,
    'activity-status': ActivityStatus,
  },
  props: ['videoPlayer', 'drillPhrase', 'activityIndex', 'activityDataLength'],
  data() {
    return {
      quizMode: false,
      triesNumber: 0,
      scoreSum: 0,
      navigationVisible: false,
    };
  },
  mounted() {
    this.updateStatusText();
    this.navigationVisible = false;
  },
  methods: {
    activityReady() {
      this.updateStatusText();
      this.navigationVisible = false;
      this.triesNumber = 0;
      (this.$refs.activity as any).startPlaying();
    },
    audioPlayed() {
      this.updateStatusText();
      (this.$refs.activity as any).recordDevice();
    },
    async deviceRecorded(payload: any) {
      const resultScore = await LearningTools
        .compareAudio(payload.blob, this.drillPhrase.id, this.$store);
      this.triesNumber += 1;
      this.updateStatusText(resultScore);
      await BbTools.sleepCancelable(LearningTools.TO_AFTER_RECORDED * 2, this.$store);
      if (this.triesNumber === 3 || resultScore > 0.79 || this.quizMode) {
        this.scoreSum += resultScore;
        this.navigationVisible = true;
      } else {
        (this.$refs.activity as any).startPlaying();
      }
    },
    async onNext() {
      this.navigationVisible = false;
      await BbTools.sleepCancelable(LearningTools.TO_HIDE_ACTIVITY, this.$store);
      this.$emit('next', this.scoreSum);
    },
    onActivityStopped() {
      this.updateStatusText();
      this.navigationVisible = false;
      this.triesNumber = 0;
    },
    updateStatusText(score = 0): void {
      if (score) {
        (this.$refs.activityStatus as any).updateScore(score);
      } else if (this.$refs && this.$refs.activityStatus) {
        (this.$refs.activityStatus as any).clearStatus();
      }
    },
  },
  beforeDestroy() {
    if (this.$store.state.sleepPromise) {
      this.$store.state.sleepPromise.cancel();
    }
  },
});
